<script lang="ts">

    import {Modal} from "flowbite-svelte";

    export let associate: any;

    export let size = "md"

    export let bgColor = "bg-neutral-500"

    let sizes = {
        sm: "h-7 w-7",
        md: "h-10 w-10",
        lg: "h-12 w-12",
        xl: "h-14 w-14",
        "2xl": "h-16 w-16"
    }

    let fontMapping = {
        sm: "text-xs",
        md: "text-base",
        lg: "text-lg",
        xl: "text-xl",
        "2xl": "text-2xl"
    }

    let showName = false;




</script>
{#if associate}
<div class="relative" on:focus={() => showName = true} on:mouseover={() => showName = true} on:mouseleave={() => showName = false}>

    <span class="inline-flex {sizes[size]} items-center justify-center rounded-full {associate.isSignatory ? 'bg-primary-500' : bgColor} ring-1 ring-primary-300">
      <span class="font-medium {fontMapping[size]} leading-none text-white">{associate?.firstName[0] + associate?.lastName[0]}</span>
    </span>
    <!--<img class="relative flex-none h-10 w-10 rounded-full " src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="">-->
    <div class="{showName ? 'block' : 'hidden'} ring ring-primary-300 absolute left-2 -bottom-5 whitespace-nowrap px-2 py-0.5 bg-white rounded text-neutral-500 z-20">{associate.firstName} {associate.lastName}</div>
</div>
{/if}




